import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  constructor(private http: HttpClient) {}

  /**
   * @param baseUrl e.g. http://localhost:8086 (no trailing slash)
   * @param userId signed-in username (must match JWT)
   * @param otherUserId optional: other party username, account name, or url slug; omit/empty for full inbox
   */
  getConversation(baseUrl: string, userId: string, otherUserId: string): Observable<any[]> {
    const obj = { userId, otherUserId: otherUserId ?? '' };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Data': btoa(JSON.stringify(obj))
    });
    return this.http.get<any[]>(`${baseUrl}/api/messages/conversation`, {
      headers,
      responseType: 'json'
    });
  }

  /**
   * POST JSON to {@code apiBase + '/send'}.
   * @param apiBase e.g. {@code `${backendURL}/api/messages`} or {@code `${backendURL}/api/reports`}
   */
  sendMessage(apiBase: string, message: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(`${apiBase}/send`, message, { headers });
  }

  /** @param baseUrl e.g. http://localhost:8086 — userId must match JWT subject (username) */
  getUnreadCount(baseUrl: string, userId: string): Observable<{ count: number }> {
    const enc = encodeURIComponent(userId);
    return this.http.get<{ count: number }>(`${baseUrl}/api/messages/unread/${enc}`);
  }
}
